<template>
  <div :style="{ padding: ($vuetify.breakpoint.xs || $vuetify.breakpoint.sm) ? '5%' : '3% 15%' }">
    <h1>Impressum</h1><br>
    <h2>Kontakt</h2>
    <p>
      Wir freuen uns über Ihre Kontaktaufnahme. Drücken Sie dazu bitte auf 
      <span class="primary--text" style="cursor: pointer" @click="contact = true">Kontaktaufnahme</span>.
    </p>
    <h2>
      tradana.org wird betrieben von:
    </h2>
    <p>
      eternio – Gesellschaft für Erinnerungskultur mbH<br>
      Campus, Gebäude A1.1<br>
      66123 Saarbrücken<br>
      Deutschland<br>
      <br>
      Telefon: 0681 965 938 84<br>
      E-Mail: hallo@tradana.org<br>
      <br>
      Vertretungsberechtigte Geschäftsführer: Henrik Bergmann, Max Jakob, Philip Pelgen und Felix Wenzel<br>
      <br>
      Umsatzsteuer-Identifikationsnummer: DE330483463<br>
      Handelsregister-Nr. und Ort: Amtsgericht Saarbrücken HRB 106569<br><br>
      Inhaltlich Verantwortlicher gemäß § 55 II RStV:<br>
      Philip Pelgen, Campus, Gebäude A1.1, 66123 Saarbrücken, Deutschland<br>
    </p>

    <h3>
      Verbraucherstreitbeilegung
    </h3>
    <p>
      Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS-Plattform) bereit, die du unter <a target="_blank" href="http://ec.europa.eu/consumers/odr/">http://ec.europa.eu/consumers/odr/</a> findest. Die OS-Plattform soll als Anlaufstelle zur außergerichtlichen Beilegung von Streitigkeiten betreffend vertragliche Verpflichtungen, die aus Online-Kaufverträgen oder Online-Dienstleistungsverträgen erwachsen, dienen. eternio nimmt nicht an dem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teil.
    </p>

    <!-- Dialog -->
    <basic-dialog :dialog="contact" @close="contact = false">
      <p class="title mb-8">
        Wie kann ich Sie erreichen?
      </p>

      <v-alert type="error" v-model="error" style="text-align: left">
        <div class="white--text">
          Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.
        </div>
      </v-alert>

      <v-alert type="error" v-model="errorAlreadySubscribed">
        <div class="white--text">
          Wir haben bereits eine Anmeldung über die angegebene E-Mail-Adresse erhalten.
        </div>
      </v-alert>

      <v-form @submit.prevent="submit" onSubmit="return false;" ref="form" class="mb-8">
        <!-- Name -->
        <v-text-field
          label="Ihr Name"
          outlined
          :error-messages="emptyName ? 'Bitte geben sie eine valide E-Mail-Adresse ein.' : ''"
          :error="emptyName"
          v-model="name"
        >
        </v-text-field>

        <!-- Ihre Telefonnummer -->
        <v-text-field
          label="Ihre Telefonnummer"
          outlined
          :error-messages="emptyPhone ? 'Bitte geben sie eine valide E-Mail-Adresse ein.' : ''"
          :error="emptyPhone"
          v-model="phone"
        >
        </v-text-field>

        <!-- Ihre E-Mail-Adresse -->
        <v-text-field
          label="Ihre E-Mail-Adresse"
          outlined
          :error-messages="notValid ? 'Bitte geben sie eine valide E-Mail-Adresse ein.' : ''"
          :error="notValid"
          v-model="mail"
        >
        </v-text-field>

        <p style="font-size: 12px; text-align: left">
          Ihre Angaben werden ausschließlich zur Kontaktaufnahme genutzt.<br>
          Mit Klick auf senden akzeptieren Sie unsere <router-link :to="{ name: 'Privacy' }" target="_blank" class="text--text">Datenschutzerklärung</router-link>.
        </p>
      </v-form>

      <v-btn class="accept white--text" x-large width="200px" @click="send">
        Senden
      </v-btn>
    </basic-dialog>

    <!-- Success -->
    <success-dialog :dialog="success" @close="success = false">
      Vielen Dank für Ihr Interesse.
      Wir befinden uns derzeit in einer 
      geschlossenen Testphase.
      <br><br>
      Wir melden uns bei Ihnen, 
      sobald wir Sie freigeschaltet haben. 
    </success-dialog>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      contact: false,
      name: '',
      phone: '',
      mail: '',
      emptyName: false,
      emptyPhone: false,
      notValid: false,
      success: false,
      error: false,
      errorAlreadySubscribed: false
    }
  },
  methods: {
    openDialog () {
      this.contact = true
    },
    send () {
      this.errorAlreadySubscribed = false
      this.emptyName = this.name === ''
      this.emptyPhone = this.phone === ''
      this.notValid = !(/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(this.mail))

      if (this.emptyName || this.emptyPhone || this.notValid) {
        return
      }

      // ---------------- Hubspot --------------------
      var data = {
        "fields": [
          {
            "objectTypeId": "0-1",
            "name": "firstname",
            "value": this.name
          },
          {
            "objectTypeId": "0-1",
            "name": "phone",
            "value": this.phone
          },
          {
            "objectTypeId": "0-1",
            "name": "email",
            "value": this.mail
          }
        ],
        "context": {
          "pageUri": "tradana.org",
          "pageName": "TRADANA"
        },
        "legalConsentOptions": {
          "consent": { // Include this object when GDPR options are enabled
            "consentToProcess": true,
            "text": "I agree to allow eternio - Gesellschaft für Erinnerungskultur mbH to store and process my personal data.",
            "communications": [
              {
                "value": true,
                "subscriptionTypeId": 999,
                "text": "I agree to receive marketing communications from eternio - Gesellschaft für Erinnerungskultur mbH."
              }
            ]
          }
        }
      }
      axios.post('https://api.hsforms.com/submissions/v3/integration/submit/25568300/5544a9fe-1686-47dd-85f8-e96e1f553b4a', data)
      // --------------------------------------------

      axios.post('/tradana/subscribeWithName', { name: this.name, phone: this.phone, mail: this.mail })
        .then(() => {
          this.contact = false
          this.success = true
          this.errorAlreadySubscribed = false
          this.error = false
          this.$ga.event('Imprint', 'Subscribed_with_Name', this.name + ' ' + this.phone + ' ' + this.mail, 0)
        })
        .catch(err => {
          if (err.response && err.response.status === 409) {
            this.errorAlreadySubscribed = true
          } else {
            this.error = true
          }
          this.success = false
        })
    }
  }
}
</script>
